import axios from "axios";
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getBranchProducts = async (q, filter_params, page, page_size, sort_by, sort_dir) => {
    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)

    const res = await axios.get(BACKEND_URL+'/branch_products', {
        params,
        withCredentials: true
    });
    return res;
}

export const createBranchProduct = async (createObj) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(BACKEND_URL+'/branch_products',
    createObj,
    {
        withCredentials: true,
        successMessage: "สินค้าได้ถูกสร้างแล้ว"
    });
    return res;
}

export const deleteBranchProduct = async (id) => {
    const res = await axios.delete(BACKEND_URL+`/branch_products/${id}`,
    {
        withCredentials: true,
        successMessage: "สินค้าได้ถูกลบแล้ว"
    });
    return res;
}
